import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Space } from 'antd'
import { Outlet } from 'react-router-dom'

const OrderHistoriesContainer = () => {
  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={translate('navBar.orderHistoriesTitle')} />
      <Outlet />
    </Space>
  )
}

export default OrderHistoriesContainer
